<script type="text/babel">
import { mapGetters } from 'vuex';
import moment from 'moment';

const HOURSPERDAY = 24;

export default {
    data () {
        return {
            dateFormat: 'DD-MM-YYYY',
            currentDate: moment(new Date()),
            sortObj: {
                mode: 'asc',
                sortType: ''
            }
        };
    },
    computed: {
        ...mapGetters({
            products : 'getProducts',
            prices: 'getAllPrices'
        }),
        originalPriceId () {
            if (!this.productChosen) {
                return;
            }
           
            return this.productChosen.price.id;
        },
        sortPromotions () {
            let {mode, sortType} = this.sortObj;
            const asc = mode === 'asc';
            if(sortType === 'startTime' || sortType === 'endTime') {
                return this.promotions.sort(
                    (a, b) =>
                        this.getTimeStamp(asc
                            ? a[sortType]
                            : b[sortType])
                        - this.getTimeStamp(asc
                            ? b[sortType]
                            : a[sortType]
                        )
                );
            } else if (sortType === 'active') {
                return this.promotions.sort((a, b) =>
                    asc ? a.active > b.active : a.active < b.active
                );
            } else if (sortType === 'quantity') {
                return this.promotions.sort((a, b) => (
                    asc ? a[sortType] : b[sortType]) - (asc ? b[sortType] : a[sortType])
                );
            } else if (sortType === 'price') {
                return this.promotions.sort((a, b) =>
                    asc ? a.price - b.price : b.price - a.price
                );
            }
            return this.promotions.sort((a, b) =>{
                let sortType = a.type == 'bulk' ? "quantity" : "startTime"
                let flag = a.type !== 'bulk'
                // console.log("a.productId > b.productId", {a: a.productId, b: b.productId, sortType, flag})
                return a.productId > b.productId ? 1 : a.productId < b.productId ? -1 : flag ? this.getTimeStamp(asc
                            ? a[sortType]
                            : b[sortType])
                        - this.getTimeStamp(asc
                            ? b[sortType]
                            : a[sortType]
                        ) : ((asc ? a[sortType] : b[sortType]) - (asc ? b[sortType] : a[sortType]))
            });
        }
    },
    methods: {
        handleSort (sortObj) {
            this.sortObj = sortObj;
        },
        getTimeStamp (date) {
            let dateObj = new Date(date);
            return dateObj.getTime();
        },
        getProductById (productId) {
            let product = this.products.find(prod => prod.id === productId);
            if (!product) {
                return 'error';
            }
            let {type, formats, code} = product;
            return `${type} ${formats[0].displayString}
                ${code && code !== 'undefined' ? 'code: ' + code : ''}`;
        },
        classList (promotion) {
            let started = this.hasStarted(promotion);
            let finished = this.hasFinished(promotion);
            let ongoing = started && !finished;
            return {
                'text-success': ongoing,
                'text-primary': !started,
                'text-danger': finished
            };
        },
        hasStarted ({startTime}) {
            return moment(startTime).startOf('day').diff(this.currentDate, 'hours') <= 0;
        },
        hasFinished ({endTime}) {
            return moment(endTime).endOf('day').diff(this.currentDate, 'hours') <= 0;
        },
        daysToStart ({startTime}) {
            let difference = moment(startTime)
                .startOf('day')
                .diff(this.currentDate, 'hours');
            return this.$t('PROMOTIONS.startsIn', {
                days: Math.floor(difference / HOURSPERDAY),
                hours: difference % HOURSPERDAY
            });
        },
        daysLeft ({endTime}) {
            let difference = moment(endTime)
                .endOf('day')
                .diff(this.currentDate, 'hours');
            return this.$t('PROMOTIONS.endsIn', {
                days: Math.floor(difference / HOURSPERDAY),
                hours: difference % HOURSPERDAY
            });
        },
        parseDate (date) {
            return moment(date).format(this.dateFormat);
        },
        isDisabled (promotion) {
            return promotion.active && (this.hasStarted(promotion) || this.hasFinished(promotion));
        }
    }
};

</script>

